<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="1000px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="120px"
      :rules="formRules"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <shortOrderInfo ref="shortOrderInfo" :order="dataForm" />
        </el-col>
        <el-col :span="12" v-if="dataForm.ChangeAppoint">
          <el-card shadow="never">
            <div slot="header">
              <span>订单改约</span>
            </div>
            <el-form-item label="改约时间">
              <el-tag type="success" >
                {{ dataForm.ChangeAppoint.reserveBegintime }}</el-tag
              >
              <el-tag type="warning">{{
                dataForm.ChangeAppoint.reserveEndtime
              }}</el-tag>
            </el-form-item>
            <el-form-item label="联系人">
              <el-tag type="success">{{
                dataForm.ChangeAppoint.userName
              }}</el-tag>
              <el-tag
                v-if="dataForm.ChangeAppoint.reservePhone"
                type="warning"
                >{{ dataForm.ChangeAppoint.reservePhone }}</el-tag
              >
              <el-tag
                v-if="dataForm.ChangeAppoint.reserveMobile"
                type="danger"
                >{{ dataForm.ChangeAppoint.reserveMobile }}</el-tag
              >
            </el-form-item>
            <el-form-item label="改约地址">
              {{ dataForm.ChangeAppoint.userAddress }}
            </el-form-item>
            <el-form-item label="改约说明">
              {{ dataForm.ChangeAppoint.remarks }}
            </el-form-item>
          </el-card>
        </el-col>
      </el-row>
      <el-form-item style="margin-top: 20px; text-align: right">
        <el-button type="success" @click="handleSubmit(true)"
          >接受改约</el-button
        >
        <el-button type="warning" @click="handleSubmit(false)"
          >拒绝改约</el-button
        >
        <el-button type="danger" @click="handleTimeOut()"
          >改约超时取消订单</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
    <script>
import { shopConfirmUserChange } from "@/api/bussiness/dzopen";
import memberSelector from "@/components/memberSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
import shortOrderInfo from "./shortOrderInfo.vue";
export default {
  components: {
    enumSelector2,
    memberSelector,
    shortOrderInfo,
  },
  data() {
    return {
      dataForm: {},
      formRules: {},
      drawerTitle: "",
      drawerVisible: false,
    };
  },
  methods: {
    show(row) {
      this.drawerTitle = "处理用户改约";
      this.drawerVisible = true;
      this.dataForm = row;
    },
    handleTimeOut() {
      let para = { key: this.dataForm.Key, accept: false,timeOut:true };
      shopConfirmUserChange(para).then((response) => {
        if (response) {
          this.drawerVisible = false;
          this.msg.successMsg("操作完成！");
          this.$emit("update");
        }
      });
    },
    handleSubmit(accept) {
      let para = { key: this.dataForm.Key, accept: accept,timeOut:false};
      shopConfirmUserChange(para).then((response) => {
        if (response) {
          this.drawerVisible = false;
          this.msg.successMsg("操作完成！");
          this.$emit("update");
        }
      });
    },
  },
  mounted() {},
};
</script>
    <style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>